import { render, staticRenderFns } from "./SdsTableSectionDefault.vue?vue&type=template&id=691bfc40&scoped=true"
import script from "./SdsTableSectionDefault.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsTableSectionDefault.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SdsTableSectionDefault.vue?vue&type=style&index=0&id=691bfc40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691bfc40",
  null
  
)

export default component.exports